module.exports = __webpack_public_path__ + "img/oirs.d73d1087.png";